import React from "react";
import { Button, Icon } from "semantic-ui-react";
import { injectIntlHelperHOC } from "../intl-helper";
import { Email } from "../social";

export const ActionButton = ({ color, icon, text, subText, ...others }) => (
  <Button labelPosition="left" size="big" color={color} icon {...others}>
    <Icon name={icon} /> {text}
    <br />
    <span style={{ fontSize: "10px" }}>{subText}</span>
  </Button>
);

export const BuyNowButton = injectIntlHelperHOC(({ intlh, color="red", ...others }) => (
  <ActionButton
    color={color}
    text={intlh("pricing.pro-plan.action.buy")}
    subText={intlh("pricing.pro-plan.action.guarantee")}
    icon="cart"
    {...others}
  />
));

export const BuyNowButtonWithDiscount = injectIntlHelperHOC(
  ({ intlh, quantity, gain, ...others }) => (
    <ActionButton
      color="orange"
      text={quantity ? intlh("volume-discount.buy-for", {count: quantity}) : intlh("pricing.pro-plan.action.buy")}
      subText={gain ? intlh("volume-discount.save", {value: gain}):''} 
      icon="cart"
      {...others}
    />
  )
);

export const ContactUsForQuotationButton = injectIntlHelperHOC(
  ({ intlh, ...others }) => (
    <ActionButton
      color="blue"
      text={intlh("pricing.site-plan.action.contact-us")}
      subText={intlh("pricing.site-plan.action.purpose")}
      icon="mail"
      as={Email}
      {...others}
    />
  )
);

export const BuyEnterpriseNowButton = injectIntlHelperHOC(({ intlh, color="red", ...others }) => (
  <ActionButton
    color={color}
    text={intlh("volume-discount.unlimited")}
    subText=''
    icon="cart"
    {...others}
  />
));